// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"49a22681","249":"c7ecb6a7","296":"d5a9954d","453":"f39b8a29","500":"ea5866d4","603":"a55df807","728":"5442c5d5","739":"bf19b7e4","903":"c67b6f47"}[chunkId] + ".chunk.js";
};